import { useEffect } from 'react';

// bug: Ionic 8+ produces Blocked aria-hidden on an element because its descendant retained focus
// https://github.com/ionic-team/ionic-framework/issues/30240
export const useRemoveAriaHidden = () => {
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          (mutation.target as Element).removeAttribute('aria-hidden');
        }
      });
      document.querySelectorAll('[aria-hidden]').forEach((el) => {
        el.removeAttribute('aria-hidden');
      });
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['aria-hidden'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);
};
